/* RESPONSIBLE TEAM: team-inbox-experience */
import type AdminSummary from 'embercom/objects/inbox/admin-summary';

/**
 * Creates a safe admin link that respects redaction status.
 *
 * @param admin - The AdminSummary object
 * @param linkHelper - The LinkWithText helper instance
 * @returns Either a plain name (if redacted) or a linked name (if not redacted)
 */
export function createSafeAdminLink(admin: AdminSummary, linkHelper: any): string {
  if (admin.isRedacted) {
    return admin.name;
  }
  // @ts-ignore helper doesn't seem to be typed correctly
  return linkHelper.compute(['apps.app.admins.admin', admin.id, admin.name]);
}
